import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';

import { cardStyles as styles } from './index';

const TitleStatusReport = ({ data }) => {
  const [buyerId, setBuyerId] = useState(null);
  const [sellerId, setSellerId] = useState(null);
  const [titleStatus, setTitleStatus] = useState();


  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'title-status-report',
      params: { 'sellerId': sellerId, 'buyerId': buyerId, status: titleStatus }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Title Status Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select style={styles.select} onChange={(e) => setSellerId(e.target.value)}>
        <option value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Buyer:</Text>
      <select style={styles.select} onChange={(e) => setBuyerId(e.target.value)}>
        <option value="">Select Buyer</option>
        {data.buyers?.map(buyer => (
          <option key={buyer.id} value={buyer.id}>
            {buyer.fullDisplayName}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Title Status:</Text>
      <select style={styles.select} onChange={(e) => setTitleStatus(e.target.value)}>
        <option key="status-all">All</option>
        <option key="status-received">Received</option>
        <option key="status-transferred">Transferred</option>
        <option key="status-release">Release</option>
        <option key="status-problem">Problem</option>
        <option key="status-missing">Missing</option>
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default TitleStatusReport;
